/* eslint-disable max-len */
import { ERRORS } from '../constants';

export default {
  ERRORS: {
    [ERRORS.INVALID_PROZIS_POINTS]:
      '¡Vaya! Los ProzisPoints que quieres compartir con el mensajero ya no están disponibles. Inténtalo de nuevo.'
  },
  MESSAGES: {
    ANSWERED_SURVEY:
      'Ya hemos recibido tus comentarios sobre la entrega del pedido {code}. \n\rEstamos deseando conocer tu opinión sobre tus próximas experiencias. 👍',
    AVAILABLE_POINTS: 'ProzisPoints disponibles:',
    DO_NOT_SHARE_YOUR_POINTS: 'No compartir ProzisPoints',
    EXPERIENCE_EVALUATION: 'CALIFICA LA EXPERIENCIA DE ENTREGA',
    FEEDBACK_HERE: 'Deja aquí tus comentarios',
    FEEDBACK_THANKS:
      'Gracias por tus comentarios sobre el servicio de entrega PROZIS NOW. \n\r¡Lo tendremos en cuenta! 💪',
    HOW_BE_BETTER:
      'Nos gustaría saber qué estamos haciendo bien y qué podemos mejorar',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    SAY_HELP_TO_COURIER: '¿Te gustaría agradecerle al mensajero?',
    SAY_HELP_TO_USER: '¿Te gustaría agradecer a quien te entregó el pedido?',
    SHARE_YOUR_POINTS:
      'Comparte tus ProzisPoints con {name}. ¡Seguro que te lo agradecerá! 😉',
    TIP_COURIER: 'Dar propina a {name}',
    TIP_USER: 'Dar una gratificación a {name}'
  }
};
